import { render, staticRenderFns } from "./performance-assessment.vue?vue&type=template&id=713188af&scoped=true"
import script from "./performance-assessment.vue?vue&type=script&lang=ts"
export * from "./performance-assessment.vue?vue&type=script&lang=ts"
import style0 from "./performance-assessment.vue?vue&type=style&index=0&id=713188af&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713188af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('713188af')) {
      api.createRecord('713188af', component.options)
    } else {
      api.reload('713188af', component.options)
    }
    module.hot.accept("./performance-assessment.vue?vue&type=template&id=713188af&scoped=true", function () {
      api.rerender('713188af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/performance-assessment/performance-assessment.vue"
export default component.exports